import AxiosInstance from "./api";

export const PaymentSalarySheetService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/salary-table", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/salary-table/" + id);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/salary-table", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/salary-table/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/salary-table/" + id);
  },
};
